var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 171,
    viewBox: "0 0 119 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.38775,
    cy: 3.77117,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1631,
    cy: 3.77117,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.9385,
    cy: 3.77117,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.7139,
    cy: 3.77117,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.38775,
    cy: 36.3135,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1631,
    cy: 36.3135,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.9385,
    cy: 36.3135,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.7139,
    cy: 36.3135,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.38775,
    cy: 68.8559,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1631,
    cy: 68.8559,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.9385,
    cy: 68.8559,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.7139,
    cy: 68.8559,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.38775,
    cy: 101.398,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1631,
    cy: 101.398,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.9385,
    cy: 101.398,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.7139,
    cy: 101.398,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.38775,
    cy: 133.941,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1631,
    cy: 133.941,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.9385,
    cy: 133.941,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.7139,
    cy: 133.941,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.38775,
    cy: 166.483,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1631,
    cy: 166.483,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.9385,
    cy: 166.483,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.7139,
    cy: 166.483,
    rx: 3.38775,
    ry: 3.77117,
    fill: "#9E4C24"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup14);
export default __webpack_public_path__ + "static/media/group-14.b1694b12bf45a58dd7cc279367e7abc0.svg";
export { ForwardRef as ReactComponent };